// client/src/pages/components/DashboardLayout.jsx
import { useLocation, useNavigate } from "react-router-dom";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import PaymentsIcon from "@mui/icons-material/Payments";
import PersonIcon from "@mui/icons-material/Person";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../redux/features/userSlice";
import "./DashboardLayout.css";

const DashboardLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);

  const userName = String(user?.fname || "").trim() || "User";
  const userEmail = String(user?.email || "").trim();
  const initial = userName.charAt(0).toUpperCase() || "U";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("balance");
    dispatch(setUser(null));
    navigate("/login");
  };

  const tabs = [
    { label: "Dashboard", path: "/user-dashboard", activePath: "/user-dashboard", icon: <SpaceDashboardIcon /> },
    { label: "Wallet", path: "/add-balance", activePath: "/add-balance", icon: <AccountBalanceWalletIcon /> },
    { label: "Orders", path: "/orders", activePath: "/orders", icon: <ReceiptLongIcon /> },
    { label: "Reseller", path: "/subscription", activePath: "/subscription", icon: <WorkspacePremiumIcon /> },
    { label: "Payments", path: "/add-balance", activePath: "/payments", icon: <PaymentsIcon /> },
    { label: "Account", path: "/user-dashboard", activePath: "/account", icon: <PersonIcon /> },
    { label: "Queries", path: "/name-check", activePath: "/name-check", icon: <HelpOutlineIcon /> },
  ];

  return (
    <div className="dashboardShell">
      <section className="dashboardHero">
        <div className="dashboardHeroArtwork" />
        <div className="dashboardHeroOverlay">
          <div className="dashboardAvatar">{initial}</div>
          <h1 className="dashboardHeroName">{userName}</h1>
          {userEmail && <p className="dashboardHeroEmail">{userEmail}</p>}

          <div className="dashboardTabs" aria-label="Dashboard navigation">
            {tabs.map((tab) => (
              <button
                key={`${tab.label}-${tab.path}`}
                type="button"
                className={`dashboardTab ${location.pathname === tab.activePath ? "active" : ""}`}
                onClick={() => navigate(tab.path)}
              >
                <span className="dashboardTabIcon">{tab.icon}</span>
                <span>{tab.label}</span>
              </button>
            ))}
            <button type="button" className="dashboardTab logout" onClick={handleLogout}>
              <span className="dashboardTabIcon">
                <LogoutIcon />
              </span>
              <span>Logout</span>
            </button>
          </div>
        </div>
      </section>

      <main className="dashboard-content">{children}</main>
    </div>
  );
};

export default DashboardLayout;
